import { render, staticRenderFns } from "./header-default.vue?vue&type=template&id=242b278c"
import script from "./header-default.vue?vue&type=script&lang=js"
export * from "./header-default.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TopbarDefault: require('C:/cata1og/cata1og-store/components/topbar/topbar-default.vue').default})
